import { toast, Bounce } from "react-toastify"

export const NETWORK_ERROR_TOAST_ID = "network-error"
export const NETWORK_ERROR_MESSAGE =
  "Connection lost or unstable. Please check your internet and try again."

const TOAST_OPTIONS = {
  position: "bottom-center",
  theme: "colored",
  transition: Bounce,
  toastId: NETWORK_ERROR_TOAST_ID,
}

const isCanceled = error =>
  error?.code === "ERR_CANCELED" ||
  error?.name === "CanceledError" ||
  error?.name === "AbortError"

export const isNetworkError = error => {
  if (!error || isCanceled(error)) return false
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return true
  }
  if (error.code === "ERR_NETWORK" || error.code === "ECONNABORTED") {
    return true
  }
  if (error.isAxiosError && !error.response) return true
  const message = String(error.message || "").toLowerCase()
  return (
    message.includes("network error") ||
    message.includes("failed to fetch") ||
    message.includes("timeout")
  )
}

export const toastNetworkError = () => {
  toast.error(NETWORK_ERROR_MESSAGE, TOAST_OPTIONS)
  return NETWORK_ERROR_MESSAGE
}

export const dismissNetworkErrorToast = () => {
  toast.dismiss(NETWORK_ERROR_TOAST_ID)
}

export const subscribeNetworkStatusToasts = () => {
  const onOffline = () => toastNetworkError()
  const onOnline = () => dismissNetworkErrorToast()

  window.addEventListener("offline", onOffline)
  window.addEventListener("online", onOnline)

  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    toastNetworkError()
  }

  return () => {
    window.removeEventListener("offline", onOffline)
    window.removeEventListener("online", onOnline)
  }
}
